import { fromJS } from 'immutable';

import * as utils from '@src/utils/duckHelpers';

const dropdownProductsTypes = {
    ...utils.requestTypes('DROPDOWN_PRODUCTS'),
};

const initialState = fromJS({
    loaded: 'loading',
    products: [],
});

const dropdownProductsReducer = (state = initialState, action) => {
    switch (action.type) {
    case dropdownProductsTypes.DROPDOWN_PRODUCTS_GET:
        return state.merge({
            loaded: 'loading',
        });
    case dropdownProductsTypes.DROPDOWN_PRODUCTS_SET:
        return state.merge({
            products: action.payload.products,
            loaded: 'complete',
        });
    default:
        return state;
    }
};

export {
    dropdownProductsTypes,
    dropdownProductsReducer as default,
};
